export type ImportedFiles = {
  [key: string]: string
}
type ImportedModule = {
  default: string
}

export function importAll(r: Record<string, unknown>): ImportedFiles {
  let files: ImportedFiles = {}
  for (const key of Object.keys(r)) {
    const module = r[key] as ImportedModule
    const file = module.default
    if (typeof file === 'string') {
      const lastFolderAndFilename = key.match(/\/([^/]+)$/)?.[1]
      if (lastFolderAndFilename) {
        files = {
          ...files,
          [lastFolderAndFilename]: file,
        }
      }
    }
  }
  return files
}

export const importAllImages = (): ImportedFiles => {
  const r = import.meta.glob('@assets/images/**/*.+(png|gif|jpg)', { eager: true })
  return importAll(r)
}

export const importAllFlagsImages = (): ImportedFiles => {
  const r = import.meta.glob('@assets/images/flags/**/*.+(jpg|webp|avif)', { eager: true })
  return importAll(r)
}

export const flagImages = importAllFlagsImages()
export const images = importAllImages()

export default {
  importAll,
  importAllImages,
  importAllFlagsImages,
}
